module.exports = __webpack_public_path__ + "img/vue1-semelle_vert.b9b4fb80.png";